import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media = section?.media?.groups?.[groupKey]?.[0];
  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseEconomicCalendarHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
  };
};

export const parseEconomicCalendarEventImpactContent = (page) => {
  const section = getSection(page, 'event-impact');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || '',
    items,
  };
};

export const parseEconomicCalendarSimpleWorkflowContent = (page) => {
  const section = getSection(page, 'simple-workflow');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const steps = [];

  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`step-${index}-title`];
    if (!title) {
      break;
    }

    steps.push({
      number: fields[`step-${index}-number`] || `${index}.`,
      title,
      description: fields[`step-${index}-description`] || '',
    });
  }

  if (steps.length === 0) {
    return null;
  }

  return {
    title: fields.title || '',
    steps,
  };
};

export const parseEconomicCalendarMacroHighlightsContent = (page) => {
  const section = getSection(page, 'macro-highlights');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    buttonText: fields.buttonText || 'Subscribe',
    privacy: {
      text: fields.privacyText || '',
      linkText: fields.privacyLinkText || 'privacy policy',
      linkUrl: fields.privacyLinkUrl || '/privacy',
    },
  };
};

export const parseEconomicCalendarBehindTheDataContent = (page) => {
  const section = getSection(page, 'behind-the-data');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/contact',
    },
  };
};
